const AppContext = {"isAdmin": false, "templateId": "temid", "downloadFileName": "template name"};
export default AppContext;